import { Popover } from '@mantine/core'
import { useState } from 'react'

export default function InfoBubble({ icon, children, reactions, animatedReactions, trackId }) {
    const [thumbsUpOpened, setThumbsUpOpened] = useState(false)
    const [thumbsDownOpened, setThumbsDownOpened] = useState(false)

    const hasThumbsUp = reactions?.thumbsUp?.length > 0
    const hasThumbsDown = reactions?.thumbsDown?.length > 0

    const thumbsUpAnimated = animatedReactions?.has(`${trackId}-thumbsUp`)
    const thumbsDownAnimated = animatedReactions?.has(`${trackId}-thumbsDown`)

    return (
        <div className="ChatInfoRow">
            <div className="ChatInfoBubble" style={{ position: 'relative' }}>
                <span className="material-symbols-outlined ChatInfoIcon">{icon}</span>
                <div className="ChatInfoBubbleText">{children}</div>

                {hasThumbsUp && (
                    <div className="ReactionCircleBottomRight">
                        <Popover
                            opened={thumbsUpOpened}
                            onChange={setThumbsUpOpened}
                            position="top"
                            withArrow
                            shadow="md"
                            styles={{
                                dropdown: {
                                    backgroundColor: '#fff',
                                    border: '1px solid #e0e0e0',
                                },
                                arrow: {
                                    backgroundColor: '#fff',
                                    border: '1px solid #e0e0e0',
                                }
                            }}
                        >
                        <Popover.Target>
                            <div
                                className={`ReactionCircle ${thumbsUpAnimated ? 'ReactionCircleAnimated' : ''}`}
                                onClick={() => setThumbsUpOpened(!thumbsUpOpened)}
                            >
                                👍
                            </div>
                        </Popover.Target>
                            <Popover.Dropdown>
                                <div className="ReactionPopoverContent">
                                    {reactions.thumbsUp.map((user, idx) => (
                                        <div key={idx} className="ReactionPopoverUser">
                                            {user.username}
                                        </div>
                                    ))}
                                </div>
                            </Popover.Dropdown>
                        </Popover>
                    </div>
                )}

                {hasThumbsDown && (
                    <div className="ReactionCircleTopRight">
                        <Popover
                            opened={thumbsDownOpened}
                            onChange={setThumbsDownOpened}
                            position="top"
                            withArrow
                            shadow="md"
                            styles={{
                                dropdown: {
                                    backgroundColor: '#fff',
                                    border: '1px solid #e0e0e0',
                                },
                                arrow: {
                                    backgroundColor: '#fff',
                                    border: '1px solid #e0e0e0',
                                }
                            }}
                        >
                        <Popover.Target>
                            <div
                                className={`ReactionCircle ${thumbsDownAnimated ? 'ReactionCircleAnimated' : ''}`}
                                onClick={() => setThumbsDownOpened(!thumbsDownOpened)}
                            >
                                👎
                            </div>
                        </Popover.Target>
                            <Popover.Dropdown>
                                <div className="ReactionPopoverContent">
                                    {reactions.thumbsDown.map((user, idx) => (
                                        <div key={idx} className="ReactionPopoverUser">
                                            {user.username}
                                        </div>
                                    ))}
                                </div>
                            </Popover.Dropdown>
                        </Popover>
                    </div>
                )}
            </div>
        </div>
    )
}

